import React from 'react'
import { useFormikContext } from 'formik'

import { FormField } from '@/components/forms/FormField'
import { TextInput } from '@/components/forms/TextInput'

import { PATH_PLACEHOLDER } from './paths'
import { RowError } from './SourceRow'

/**
 * A single glom path, injected through the schema `raw`/`as` hatch.
 *
 * Raw rather than a plain `text` descriptor because AbstractForm's TextField renders
 * errors through getFieldErrorMessage, which is gated on `touched` -- and a stored
 * config is validated on mount without anything being touched. A saved config with a
 * bad path would disable Save with nothing on screen saying why, which is the bug
 * RowError's docstring records having already been shipped and fixed once.
 */
export const PathField = ({ name, label, description, required, placeholder }) => {
  const { values, errors, setFieldValue } = useFormikContext()

  return (
    <FormField required={required} data-testid={`${name}-field`}>
      <label>{label}</label>
      {description && <div className="form-caption">{description}</div>}
      <TextInput
        value={values[name] || ''}
        placeholder={placeholder || PATH_PLACEHOLDER}
        data-testid={name}
        aria-label={label}
        onChange={(event) => setFieldValue(name, event.target.value)}
        // Trim on blur, not on change: a predicate value legitimately contains
        // spaces, and trimming per keystroke would eat one as it is typed.
        onBlur={(event) => {
          const trimmed = event.target.value.trim()
          if (trimmed !== event.target.value) {
            setFieldValue(name, trimmed)
          }
        }}
      />
      <RowError message={errors[name]} />
    </FormField>
  )
}
